if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.combinedPdfGeneratorButton = this.querySelector('#swymcs-generate-combined-pdf');
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

                /* Share List popup selectors */ 
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
                this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
                
                /* Delete List popup selectors */ 
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
                this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = this.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list'); 

            /* Wishlist Footer selectors */
            this.wishlistFooter = this.querySelector('#swymcs-total-container');
            this.subTotalField = this.querySelector('#swymcs-wishlist-total');
            this.addAddToCartButton = this.querySelector('#swymcs-add-all-to-cart-btn');
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.combinedPdfGeneratorButton.addEventListener('click', this._generateCombinedPdf.bind(this));
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
             
                /* Share List Events */
                this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
                this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.productsContainer.addEventListener('change', this._eventsForProductsGrid);
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));

            /* Wishlist Footer buttons */
            this.addAddToCartButton.addEventListener('click', this._addAllProductToCart.bind(this));
        }

        async _triggerBackToListView(){
            this._renderWishlist(_swat);
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this.lists = await this._getLists();
            this.lists.length ? this._renderWishlists() : this._renderEmptyState();
        }

        async _renderShareWishlist(){
            const params = new URL(document.location).searchParams;
            const lid = params.get("lid");
            if(!lid){
                this._renderProductsGrid([], []);
                this._hideContainer(this.wishlistHeader);
                this._hideContainer(this.backToListView)
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }
            const wishlistProducts = await this._getProductsFromList(lid);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            await this._renderSharedListHeader(lid);
            this._renderProductsGrid(shopifyProductsData, wishlistProducts);
            this._hideContainer(this.backToListView)
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderWishlists() {
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            let html = ``;
            this.lists.forEach(list => {
                const listContents = list?.listcontents || [];

                let buttonText = !listContents.length ? 'Continue Shopping' : 'View List';
                let buttonAction = !listContents.length ? 'shop' : 'view-list';
                let imageHtml = `<div class="swymcs-list-image-container">`;
                if(listContents.length){
                    for(let i = 0; i < 3; i++){
                        if(listContents[i]){
                            imageHtml += `
                                <div class="swymcs-wishlist-image-wrapper">
                                    <img src="${listContents[i].iu}" alt="${listContents[i].dt}" class="swymcs-wishlist-image"/>
                                </div>`;
                        }
                    }
                    imageHtml += '</div>';
                }
                else imageHtml += ` <p class="swymcs-no-products-message">This is an empty list!</p></div>`;

                html += `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" data-lid="${list.lid}" aria-label="View list ${list.lname}" id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${listContents.length}</span>
                            <span class="swymcs-product-count-text">${listContents.length > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" data-action="${buttonAction}" id="swymcs-view-list-button-${list.lid}" aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            });
            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._scrollToTop();
        }

        async _renderListProducts(lid){
            window.currentActiveListId = lid;
            const wishlistProducts = await this._getProductsFromList(lid);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            this._renderListHeader(lid);
            this._renderProductsGrid(shopifyProductsData, wishlistProducts);
            this._hideContainer(this.listsContainer);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSharedListHeader(lid){
            const activeList = await this._getListDetails(lid);
            this._renderActiveList(activeList.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const listContents = list?.listcontents || [];
                if(listContents.length){
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${listContents[0].iu}" alt="listContents[0].dt"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const listContent = list?.listcontents || [];
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts, wishlistProducts){
            if(!wishlistProducts.length) {
                this._renderEmptyList();
                return;
            }
            let productMarkup = ``;
            wishlistProducts.forEach((pdp, index) => {
                const product = shopifyProducts[index];
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                const selectedVariantPrice = window.isCustomer ? pdp?.cprops?.wholesalePrice || parseFloat(selectedVariant.price/100.00).toFixed(2) : parseFloat(selectedVariant.price/100.00).toFixed(2);
                const addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                const isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const pdfUrl = pdp?.cprops?.pdfUrl || ''; 
                const productUrl = pdp?.product?.du || pdp.du;
                productMarkup += `
                <li class="${isSoldOut} swymcs-wishlist-grid-item-container" id="wishlist-grid-item--${index}" data-url="${pdp.du}" data-lid="${lid}" data-epi="${pdp.epi}" data-variant-cost="${selectedVariantPrice}">
                    <div aria-labelledby="${product.title}" role="button" tabindex="0" class="swymcs-wishlist-grid-item swymcs-wishlist-item swymcs-list-product">
                        <div class="swymcs-wl-action-cta-container">
                            <button data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-has-after-css swymcs-button swymcs-product-delete-btn swym-nav swym-nav-1 swym-is-button" aria-label="${this.settings.swym_delete_list_text} ${product.title}">
                                <span class="swym-text badge">${this.settings.swym_delete_list_text}</span>
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                            <button data-purpose="pdf" class="${!pdfUrl.length ? 'swym-hide-container' : 'swymcs-has-pdf-link'} swymcs-has-after-css swymcs-button" aria-label="${this.settings.swym_download_pdf_text} for ${product.title}" data-pdf-url="${pdfUrl}">
                                <span class="swym-text badge">${this.settings.swym_download_pdf_text}</span>
                                <span class="swym-icon">${this.settings.swym_download_pdf_icon}</span>
                            </button>
                        </div>
                        <div class="swymcs-wishlist-product-image-wrapper">
                            <a href="${productUrl}">
                                ${imageSrc ? `<img class="swymcs-wishlist-image" src="${imageSrc}" alt="${product.title}"/>` : '<svg version="1.1" class="swymcs-wishlist-image" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 97.96 122.88" style="enable-background:new 0 0 97.96 122.88" xml:space="preserve"><g><path fill="currentcolor" d="M66.77,0.69C66.31,0.28,65.66,0,65.02,0c-0.14,0-0.28,0-0.41,0.05H5.88c-1.57,0-3.04,0.64-4.1,1.7 c-1.06,1.06-1.71,2.49-1.71,4.1v54.98L0,60.88v6.81l0.07-0.04v0.64c4.36-2.85,8.22-5.6,12.63-8.26l15.44,18.38l17.46-20.78 l15.4,18.33l23.89-16.42l5.42,3.73v0l7.54,5.18V33.86c0.05-0.23,0.09-0.41,0.09-0.64c0-0.78-0.37-1.47-0.87-1.98l-30-30.36 C67,0.79,66.95,0.74,66.86,0.7L66.77,0.69L66.77,0.69L66.77,0.69z M7.61,56.71V8.24c0-0.18,0.05-0.32,0.18-0.42 c0.09-0.09,0.23-0.18,0.42-0.18h52.53l0,0l0,0v20.92c0,2.17,0.88,4.74,2.3,6.17c1.43,1.43,4.45,2.6,6.62,2.6h20.66v19.83 l-5.42-3.73l-22.55,15.5L45.62,49.01L28.16,69.8l-14-16.67L7.61,56.71L7.61,56.71z M90.33,82.9l-5.42-3.73L56.75,98.52L45.63,85.28 l-17.49,20.81L8.05,82.17l-0.46,0.22c-0.06,10.89-0.15,32.35,0.21,32.71c0.1,0.13,0.28,0.18,0.42,0.18 c7.72,0,81.25,0.35,81.79-0.18c0.13-0.09,0.33-0.27,0.33-0.41V82.9L90.33,82.9z M0.07,85.89L0,85.93v-5.08l9.5-5.57l18.65,22.2 l17.48-20.8l12.45,14.82l26.83-18.43l5.42,3.73v0l7.54,5.18v35.11c0,1.61-0.64,3.04-1.7,4.1c-1.06,1.05-2.49,1.7-4.1,1.7 c-29.44,0-56.59,0-86.19,0c-1.61,0-3.04-0.64-4.1-1.7c-1.06-1.06-1.71-2.49-1.71-4.1V85.89L0.07,85.89z M67.6,27.97V8.94 l21.43,21.7H70.27c-0.74,0-1.38-0.32-1.89-0.78C67.92,29.4,67.6,28.7,67.6,27.97L67.6,27.97L67.6,27.97z"/></g></svg>'}
                            </a>
                        </div>
                        <div class="swym-product-title cart__items__title">
                            <p><a href="${productUrl}">${product.title}</a></p>
                            <div class="cart__items__meta">
                                ${selectedVariantTitle ? `<p class="body-size-3">${selectedVariantTitle}</p>`: ``}
                            </div>
                        </div>
                        <div data-purpose="none" class="swymcs-product-price line__price">${currencyCode}${selectedVariantPrice}</div>
                        <div class="swym-quantity-selector-wrapper">
                            <div class="swym-quantity-selector quantity__wrapper">
                                <button data-step="1" class="quantity__button quantity__button--minus swym-qty-btn" data-action="minus" aria-label="Minus">-</button>
                                <input readonly data-step="1" class="quantity__input swym-qty-input" type="text" value="1" aria-label="Quanity Input"/>
                                <button data-step="1" class="quantity__button quantity__button--plus swym-qty-btn" data-action="plus" aria-label="Plus">+</button>    
                            </div>
                        </div>
                        <div data-purpose="none" class="swymcs-product-total-price">${currencyCode}${selectedVariantPrice}</div>
                        <div class="swymcs-product-buttons">
                            <button ${isSoldOut ? 'disabled': ''} data-purpose="cart" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" 
                                class="${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}">
                                ${addToCartBtnText}
                            </button>
                        </div>
                    </div>
                </li>`;
            });
            this.productsContainer.innerHTML = productMarkup;
            this._scrollToTop();
            this._addEventListenersToQty();
            this._updatePageFooter();
        }

        _updatePageFooter(){
            const wishlistedItems = this.querySelectorAll('.swymcs-wishlist-grid-item-container:not(.swymcs-sold-out)');
            let quantities = [], prices = [];
            wishlistedItems.forEach(container => {
                prices.push(+container.dataset.variantCost);
                quantities.push(+container.querySelector('.quantity__input').value);
            });
            const totalPrice = parseFloat(prices.reduce(((sum, price, index)=> sum + (price * quantities[index])), 0)).toFixed(2);
            this.subTotalField.innerHTML = `${currencyCode}${totalPrice}`;
            this._showContainer(this.wishlistFooter);
        }

        _addEventListenersToQty(){
            this.qtyButtons = this.querySelectorAll('.swym-qty-btn');
            this.inputQty = this.querySelectorAll('.swym-qty-input');
            this.qtyButtons.forEach(btn => {btn.addEventListener('click', this._manageQtyBtn.bind(this))})
        }

        _manageQtyBtn(e){
            const page = document.querySelector('swym-wishlist-page');
            let action = e.target.dataset.action;
            let inputQty = e.target.closest("li").querySelector(".swym-qty-input");
            let variantPrice = +e.target.closest("li").dataset.variantCost;
            let totalItemPriceField = e.target.closest("li").querySelector(".swymcs-product-total-price");
            let quantity = +inputQty.value;
            let step = +e.target.dataset.step;
            if(action == 'minus'){
                if(quantity == step) return;
                quantity -= step;
            }
            else quantity += step;
            inputQty.value = quantity;
            const totalPrice = parseFloat(quantity * variantPrice).toFixed(2);
            totalItemPriceField.textContent = `${currencyCode}${totalPrice}`;
            page._updatePageFooter();
        }

        _renderEmptyList(){
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
            this._hideContainer(this.wishlistFooter);
        }

        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }

        async _getShopifyProductsData(products){
            if(!products.length) return [];
            let res = await Promise.all(products.map(async (pdp) => {
                const productHandle = pdp.du.split('/products/')[1].split('?')[0];
                const reqURL = `/products/${productHandle}.js`;
                const productData = await fetch(reqURL);
                const jsonData = await productData.json();
                return jsonData;
            }));
            return res;
        }

        _deleteProductFromList(product, lid, parentNode){
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('li')){
                    this._renderProductsGrid([], []);
                }
                this.lists = await this._getLists();
                this._renderListHeader(lid);
                this._updatePageFooter();
            }
            const onError = error => console.log("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
                "lnote": ""
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                this.lists = await this._getLists();
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                this.lists = await this._getLists();
                this._renderListProducts(listObj.lid);
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this._renderWishlist(_swat);
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const inputQty = button.closest("li").querySelector(".swym-qty-input");
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: +inputQty.value
            }, epi, (c) => {
                button.classList.add('swymcs-product-in-cart');
                button.textContent = 'Added to cart'; 
                _cartRefresh();
            }, (error) => {
                button.textContent = 'Add to cart';
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        async _addAllProductToCart(evt) {
            const page = this;
            try {
                const productsData = [...page.querySelectorAll('.swymcs-wishlist-grid-item-container:not(.swymcs-sold-out)')].map(container => ({
                    id: +container.dataset.epi,
                    quantity: +container.querySelector('.quantity__input').value
                }));
                let formData = { 'items': productsData };
        
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
        
                const cartResponse = await response.json();
                cartResponse.items.forEach(item => {
                    const variantId = item.id;
                    const button = page.querySelector(`.swymcs-add-to-cart-btn[data-epi="${variantId}"]`);
                    button.textContent = 'Added to cart';
                });
                evt.target.textContent = 'Added to cart';
                this._scrollToTop();
                setTimeout(
                    ()=> { location.href = '/cart' }, 500
                )
            } catch (error) {
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
                console.error('Error:', error);
            }
        }

        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(){
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-wishlist-page');
            const lid = evt.target.dataset.lid;
            page._renderListHeader(window.currentActiveListId);
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        /* Product Grid Events */

        async _updateProductSequenceInList(seq){ 
            const lid = window.currentActiveListId;
            const listProducts = await this._getProductsFromList(lid);
            const sequenceMap = {};
            seq.forEach(item => {
                sequenceMap[item.epi] = item.index;
            });
            listProducts.forEach(product => {
                const epi = product.epi;
                if (epi in sequenceMap) {
                    product.cprops = product.cprops || {};
                    product.cprops.index = sequenceMap[epi];
                }
            });
            return listProducts;
        }
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            if(target.id == 'swymcs-products-grid') return;
            const purpose = target.dataset.purpose;
            const page = document.querySelector('swym-wishlist-page');
            if(purpose == 'none') return; 
            else if(purpose == 'cart') page._addProductToCart(target)
            else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('li')
                );
            } else if(purpose == 'link'){
                const url = target.dataset.url;
                location.href = url;
            } else if(purpose == 'pdf'){
                const pdfUrl = target.dataset.pdfUrl;
                const fileName = pdfUrl.split('files/')[1].split('?')[0];
                page._generatePdf([pdfUrl], fileName);
            }
        }

        _generateCombinedPdf(){
            const pdfButtons = [...this.querySelectorAll('.swymcs-has-pdf-link')];
            const pdfUrls = pdfButtons.map(button => button.dataset.pdfUrl);
            const pdfName = `${this.settings.swym_default_pdf_file_name}.pdf`;
            pdfUrls.length ? this._generatePdf(pdfUrls, pdfName) : _swat.ui.uiRef.showErrorNotification({message: this.settings.swym_no_pdf_file_attached});
        }

        async _generatePdf(pdfArray, pdfName){
            const buffers = await Promise.all(pdfArray.map(url => fetch(url).then(response => response.arrayBuffer())));
            const pdfDocs = await Promise.all(buffers.map(buffer => window.PDFLib.PDFDocument.load(buffer))); 
            const mergedPdf = await window.PDFLib.PDFDocument.create();
            for (const pdfDoc of pdfDocs) {
                const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                pages.forEach(page => mergedPdf.addPage(page));
            }
            const mergedPdfBytes = await mergedPdf.save();
            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = pdfName;
            link.click();
        }

        /* Additional Options */


    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}